import _defineProperty from "/home/runner/work/spa/spa/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
var _EVENTS_TO_FUNCTIONS;
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { formatMoney } from '@spa/shared/utils';
import Locales from '@spa/shared/constants/locales';
import { photoUrl } from '@spa/shared/utils/photos';
import { EVENTS } from '@spa/offer/constants/tracking';
import { getPropertyRentBy } from '@spa/shared/utils/property';
import { translateFromLanguage } from '@spa/shared/utils/transformers';
import { transformFeaturesProperty, lastUpdate, transformRulesProperty, verificationLevel } from '@spa/offer/utils/transformers';
var clickSelectDates = function clickSelectDates() {
  return {
    event: EVENTS.CLICK_SELECT_DATES
  };
};
var clickRequestToBook = function clickRequestToBook() {
  return {
    event: EVENTS.CLICK_REQUEST_TO_BOOK
  };
};
var requestIntention = function requestIntention() {
  return {
    event: EVENTS.REQUEST_INTENTION
  };
};
var clickMoreListings = function clickMoreListings() {
  return {
    event: EVENTS.CLICK_MORE_LISTINGS
  };
};
var clickMorePlacesLikeThis = function clickMorePlacesLikeThis() {
  return {
    event: EVENTS.CLICK_MORE_PLACES_LIKE_THIS
  };
};
var viewOfferPage = function viewOfferPage(_ref) {
  var _profile$profile, _profile$profile$cont, _profile$profile2, _profile$profile2$bas, _profile$profile2$bas2, _priceDetails$request, _priceDetails$request2, _priceDetails$request3, _priceDetails$request4, _profile$registration;
  var _ref$trackingData = _ref.trackingData,
    language = _ref$trackingData.language,
    profile = _ref$trackingData.profile,
    property_aggregate = _ref$trackingData.property_aggregate,
    globalization_aggregate = _ref$trackingData.globalization_aggregate,
    accommodation_offer = _ref$trackingData.accommodation_offer,
    accommodation_provider = _ref$trackingData.accommodation_provider,
    priceDetails = _ref$trackingData.priceDetails,
    notificationEmail = _ref.notificationEmail,
    referrer = _ref.referrer,
    offerGenderRestriction = _ref.offerGenderRestriction,
    propertyGenderRestriction = _ref.propertyGenderRestriction;
  var _accommodation_offer$ = accommodation_offer.costs.bills,
    electricity = _accommodation_offer$.electricity,
    water = _accommodation_offer$.water,
    gas = _accommodation_offer$.gas,
    internet = _accommodation_offer$.internet;
  var billsIncluded = electricity.included && water.included && gas.included && internet.included ? 'yes' : 'no';
  var address = property_aggregate.property.location.address.street;
  var city = globalization_aggregate.city.metadata.name_translations.find(function (_ref2) {
    var _ref3;
    var locale_code = _ref2.locale_code;
    return (_ref3 = locale_code === Locales[language.toUpperCase()]) !== null && _ref3 !== void 0 ? _ref3 : Locales.EN;
  });
  var country = globalization_aggregate.country.metadata.name_translations.find(function (_ref4) {
    var _ref5;
    var locale_code = _ref4.locale_code;
    return (_ref5 = locale_code === Locales[language.toUpperCase()]) !== null && _ref5 !== void 0 ? _ref5 : Locales.EN;
  });
  var street = "".concat(address, ", ").concat(city === null || city === void 0 ? void 0 : city.text, ", ").concat(country === null || country === void 0 ? void 0 : country.text);
  var unitType = accommodation_offer.property.unit_type;
  var _property_aggregate$p = property_aggregate.property,
    lifecycle = _property_aggregate$p.lifecycle,
    typology = _property_aggregate$p.typology;
  return {
    event: EVENTS.VIEW_OFFER_PAGE,
    accommodationType: property_aggregate.property.typology.accommodation_type_code,
    billsIncluded: billsIncluded,
    category: property_aggregate.property.typology.accommodation_type_code,
    city: globalization_aggregate.city.code,
    country: globalization_aggregate.country.code,
    email: profile === null || profile === void 0 ? void 0 : (_profile$profile = profile.profile) === null || _profile$profile === void 0 ? void 0 : (_profile$profile$cont = _profile$profile.contacts) === null || _profile$profile$cont === void 0 ? void 0 : _profile$profile$cont.email_address,
    features: transformFeaturesProperty(property_aggregate),
    id: accommodation_offer.id,
    lastUpdate: lastUpdate(accommodation_offer),
    loginStatus: profile.isLoggedIn,
    locale: (profile === null || profile === void 0 ? void 0 : (_profile$profile2 = profile.profile) === null || _profile$profile2 === void 0 ? void 0 : (_profile$profile2$bas = _profile$profile2.basic_info) === null || _profile$profile2$bas === void 0 ? void 0 : (_profile$profile2$bas2 = _profile$profile2$bas.preference_settings) === null || _profile$profile2$bas2 === void 0 ? void 0 : _profile$profile2$bas2.locale_code) || language,
    localeCode: language,
    minimumStay: accommodation_offer.requisites.conditions.minimum_nights,
    moveInDate: (_priceDetails$request = priceDetails === null || priceDetails === void 0 ? void 0 : (_priceDetails$request2 = priceDetails.request) === null || _priceDetails$request2 === void 0 ? void 0 : _priceDetails$request2.moveIn) !== null && _priceDetails$request !== void 0 ? _priceDetails$request : null,
    moveOutDate: (_priceDetails$request3 = priceDetails === null || priceDetails === void 0 ? void 0 : (_priceDetails$request4 = priceDetails.request) === null || _priceDetails$request4 === void 0 ? void 0 : _priceDetails$request4.moveOut) !== null && _priceDetails$request3 !== void 0 ? _priceDetails$request3 : null,
    pageLanguage: language,
    path: document.referrer,
    policy: accommodation_offer.requisites.conditions.cancellation_policy,
    price: accommodation_offer.reference_price.amount / 100,
    currency: accommodation_offer.reference_price.currency_code,
    propertyType: property_aggregate.property.typology.type_code,
    rentType: getPropertyRentBy({
      unitType: unitType,
      lifecycle: lifecycle,
      typology: typology
    }),
    rules: transformRulesProperty(property_aggregate),
    signupContext: profile === null || profile === void 0 ? void 0 : (_profile$registration = profile.registration) === null || _profile$registration === void 0 ? void 0 : _profile$registration.context,
    street: street,
    title: accommodation_offer.title[0].text,
    verificationLevel: verificationLevel(property_aggregate, accommodation_provider),
    notificationEmail: notificationEmail,
    referrer: referrer,
    offerGenderRestriction: offerGenderRestriction,
    propertyGenderRestriction: propertyGenderRestriction
  };
};
export var addToWishlist = function addToWishlist(_ref6) {
  var offer = _ref6.offer,
    citySlug = _ref6.citySlug,
    neighborhood = _ref6.neighborhood,
    language = _ref6.language;
  var id = offer.id,
    main_photo = offer.main_photo,
    title = offer.title,
    reference_price = offer.reference_price;
  var photo = !main_photo ? null : photoUrl({
    hash: main_photo.id
  });
  var offerUrl = "".concat(window.location.hostname, "/accommodation/").concat(citySlug, "/").concat(id);
  var priceFormatted = !reference_price.amount || !reference_price.currency_code ? null : formatMoney(reference_price.amount, reference_price.currency_code);
  var neighborhoodTranslated = !neighborhood ? null : translateFromLanguage(neighborhood.metadata.name_translations, language);
  var titleTranslated = !title ? null : translateFromLanguage(title, language);
  return {
    event: EVENTS.ADD_TO_WISHLIST,
    id: id,
    title: titleTranslated,
    neighbourhood: neighborhoodTranslated,
    photoUrl: photo,
    offerUrl: offerUrl,
    price: priceFormatted
  };
};
var suggestedDatesShown = function suggestedDatesShown(_ref7) {
  var contractType = _ref7.contractType;
  return {
    event: EVENTS.SUGGESTED_DATES_SHOWN,
    'contract-type': contractType
  };
};
var selectedSuggestedDates = function selectedSuggestedDates() {
  return {
    event: EVENTS.SELECTED_SUGGESTED_DATES
  };
};
var selectedOriginalDates = function selectedOriginalDates() {
  return {
    event: EVENTS.SELECTED_ORIGINAL_DATES
  };
};
var reportListingOpen = function reportListingOpen() {
  return {
    event: EVENTS.REPORT_LISTING_OPEN
  };
};
var reportListingSubmit = function reportListingSubmit(_ref8) {
  var reason = _ref8.reason,
    offerId = _ref8.offerId;
  return {
    event: EVENTS.REPORT_LISTING_SUBMIT,
    reason: reason,
    offerId: offerId
  };
};
var shareLink = function shareLink() {
  return {
    event: EVENTS.SHARE_LINK
  };
};
var referralClick = function referralClick(_ref9) {
  var context = _ref9.context;
  return {
    event: EVENTS.REFERRAL_CLICK,
    label: "offer-page-".concat(context)
  };
};
var fixedContractModalOpen = function fixedContractModalOpen(_ref10) {
  var offer = _ref10.offer;
  return {
    event: EVENTS.FIXED_CONTRACT_MODAL_OPEN,
    offer: offer
  };
};
var fixedContractOptionClick = function fixedContractOptionClick(_ref11) {
  var option = _ref11.option,
    offer = _ref11.offer;
  return {
    event: EVENTS.FIXED_CONTRACT_OPTION_CLICK,
    offer: offer,
    option: option
  };
};
var fixedContractConfirmClick = function fixedContractConfirmClick(_ref12) {
  var offer = _ref12.offer;
  return {
    event: EVENTS.FIXED_CONTRACT_CONFIRM_CLICK,
    offer: offer
  };
};
var fixedContractCancelClick = function fixedContractCancelClick(_ref13) {
  var offer = _ref13.offer;
  return {
    event: EVENTS.FIXED_CONTRACT_CANCEL_CLICK,
    offer: offer
  };
};
var offerPageFaqOpened = function offerPageFaqOpened(_ref14) {
  var question = _ref14.question;
  return {
    event: EVENTS.OFFER_PAGE_FAQ_OPENED,
    'clicked-text': question
  };
};
var uniTrustClicked = function uniTrustClicked(_ref15) {
  var url = _ref15.url;
  return {
    event: EVENTS.UNI_TRUST_CLICKED,
    source: 'offer-page',
    url: url
  };
};
var quickPageNavigation = function quickPageNavigation(_ref16) {
  var sectionName = _ref16.sectionName;
  return {
    event: EVENTS.QUICK_PAGE_NAVIGATION,
    sectionName: sectionName
  };
};
var galleryOpened = function galleryOpened() {
  return {
    event: EVENTS.GALLERY_OPENED
  };
};
var mapOpened = function mapOpened() {
  return {
    event: EVENTS.MAP_OPENED
  };
};
var seeAllAmenities = function seeAllAmenities() {
  return {
    event: EVENTS.SEE_ALL_AMENITIES
  };
};
var allFeaturesModalOpened = function allFeaturesModalOpened() {
  return {
    event: EVENTS.ALL_FEATURES_MODAL_OPENED
  };
};
var photosCarouselOpened = function photosCarouselOpened() {
  return {
    event: EVENTS.PHOTOS_CAROUSEL_OPENED
  };
};
var quickGalleryNavigation = function quickGalleryNavigation(_ref17) {
  var label = _ref17.label;
  return {
    event: EVENTS.QUICK_GALLERY_NAVIGATION,
    label: label
  };
};
var sharedOffer = function sharedOffer(_ref18) {
  var method = _ref18.method;
  return {
    event: EVENTS.SHARED_OFFER,
    method: method
  };
};
var helpCenter = function helpCenter(_ref19) {
  var destination = _ref19.destination;
  return {
    event: EVENTS.HELP_CENTER,
    destination: destination
  };
};
var priceReview = function priceReview(_ref20) {
  var context = _ref20.context;
  return {
    event: EVENTS.PRICE_REVIEW,
    context: context
  };
};
var requestToBookAmplitude = function requestToBookAmplitude(_ref21) {
  var moveIn = _ref21.moveIn,
    moveOut = _ref21.moveOut,
    guests = _ref21.guests,
    optionId = _ref21.optionId,
    offerId = _ref21.offerId,
    price = _ref21.price,
    currencyCode = _ref21.currencyCode,
    availableFrom = _ref21.availableFrom,
    propertyType = _ref21.propertyType,
    offerType = _ref21.offerType,
    city = _ref21.city,
    country = _ref21.country,
    offerGenderRestriction = _ref21.offerGenderRestriction,
    propertyGenderRestriction = _ref21.propertyGenderRestriction;
  return {
    event: EVENTS.REQUEST_TO_BOOK_AMPLITUDE,
    moveIn: moveIn,
    moveOut: moveOut,
    guests: guests,
    optionId: optionId,
    offerId: offerId,
    price: price,
    currencyCode: currencyCode,
    availableFrom: availableFrom,
    propertyType: propertyType,
    offerType: offerType,
    city: city,
    country: country,
    offerGenderRestriction: offerGenderRestriction,
    propertyGenderRestriction: propertyGenderRestriction
  };
};
var floorPlanOpened = function floorPlanOpened() {
  return {
    event: EVENTS.FLOOR_PLAN_OPENED
  };
};
var videoOpened = function videoOpened() {
  return {
    event: EVENTS.VIDEO_OPENED
  };
};
export var EVENTS_TO_FUNCTIONS = (_EVENTS_TO_FUNCTIONS = {}, _defineProperty(_EVENTS_TO_FUNCTIONS, EVENTS.CLICK_SELECT_DATES, clickSelectDates), _defineProperty(_EVENTS_TO_FUNCTIONS, EVENTS.CLICK_REQUEST_TO_BOOK, clickRequestToBook), _defineProperty(_EVENTS_TO_FUNCTIONS, EVENTS.REQUEST_INTENTION, requestIntention), _defineProperty(_EVENTS_TO_FUNCTIONS, EVENTS.CLICK_MORE_LISTINGS, clickMoreListings), _defineProperty(_EVENTS_TO_FUNCTIONS, EVENTS.CLICK_MORE_PLACES_LIKE_THIS, clickMorePlacesLikeThis), _defineProperty(_EVENTS_TO_FUNCTIONS, EVENTS.VIEW_OFFER_PAGE, viewOfferPage), _defineProperty(_EVENTS_TO_FUNCTIONS, EVENTS.ADD_TO_WISHLIST, addToWishlist), _defineProperty(_EVENTS_TO_FUNCTIONS, EVENTS.SUGGESTED_DATES_SHOWN, suggestedDatesShown), _defineProperty(_EVENTS_TO_FUNCTIONS, EVENTS.SELECTED_SUGGESTED_DATES, selectedSuggestedDates), _defineProperty(_EVENTS_TO_FUNCTIONS, EVENTS.SELECTED_ORIGINAL_DATES, selectedOriginalDates), _defineProperty(_EVENTS_TO_FUNCTIONS, EVENTS.REPORT_LISTING_OPEN, reportListingOpen), _defineProperty(_EVENTS_TO_FUNCTIONS, EVENTS.REPORT_LISTING_SUBMIT, reportListingSubmit), _defineProperty(_EVENTS_TO_FUNCTIONS, EVENTS.SHARE_LINK, shareLink), _defineProperty(_EVENTS_TO_FUNCTIONS, EVENTS.REFERRAL_CLICK, referralClick), _defineProperty(_EVENTS_TO_FUNCTIONS, EVENTS.FIXED_CONTRACT_MODAL_OPEN, fixedContractModalOpen), _defineProperty(_EVENTS_TO_FUNCTIONS, EVENTS.FIXED_CONTRACT_OPTION_CLICK, fixedContractOptionClick), _defineProperty(_EVENTS_TO_FUNCTIONS, EVENTS.FIXED_CONTRACT_CONFIRM_CLICK, fixedContractConfirmClick), _defineProperty(_EVENTS_TO_FUNCTIONS, EVENTS.FIXED_CONTRACT_CANCEL_CLICK, fixedContractCancelClick), _defineProperty(_EVENTS_TO_FUNCTIONS, EVENTS.OFFER_PAGE_FAQ_OPENED, offerPageFaqOpened), _defineProperty(_EVENTS_TO_FUNCTIONS, EVENTS.UNI_TRUST_CLICKED, uniTrustClicked), _defineProperty(_EVENTS_TO_FUNCTIONS, EVENTS.QUICK_PAGE_NAVIGATION, quickPageNavigation), _defineProperty(_EVENTS_TO_FUNCTIONS, EVENTS.GALLERY_OPENED, galleryOpened), _defineProperty(_EVENTS_TO_FUNCTIONS, EVENTS.MAP_OPENED, mapOpened), _defineProperty(_EVENTS_TO_FUNCTIONS, EVENTS.SEE_ALL_AMENITIES, seeAllAmenities), _defineProperty(_EVENTS_TO_FUNCTIONS, EVENTS.ALL_FEATURES_MODAL_OPENED, allFeaturesModalOpened), _defineProperty(_EVENTS_TO_FUNCTIONS, EVENTS.PHOTOS_CAROUSEL_OPENED, photosCarouselOpened), _defineProperty(_EVENTS_TO_FUNCTIONS, EVENTS.QUICK_GALLERY_NAVIGATION, quickGalleryNavigation), _defineProperty(_EVENTS_TO_FUNCTIONS, EVENTS.SHARED_OFFER, sharedOffer), _defineProperty(_EVENTS_TO_FUNCTIONS, EVENTS.HELP_CENTER, helpCenter), _defineProperty(_EVENTS_TO_FUNCTIONS, EVENTS.PRICE_REVIEW, priceReview), _defineProperty(_EVENTS_TO_FUNCTIONS, EVENTS.REQUEST_TO_BOOK_AMPLITUDE, requestToBookAmplitude), _defineProperty(_EVENTS_TO_FUNCTIONS, EVENTS.FLOOR_PLAN_OPENED, floorPlanOpened), _defineProperty(_EVENTS_TO_FUNCTIONS, EVENTS.VIDEO_OPENED, videoOpened), _EVENTS_TO_FUNCTIONS);
export var transform = function transform(event, payload) {
  return _objectSpread({
    page: 'offer'
  }, EVENTS_TO_FUNCTIONS[event](payload));
};